(function () {
  if (typeof window !== "undefined") {
    if (window.__amPeople) return;
    window.__amPeople = true;
  }

  var SPLIT_MIN = 4;
  var SPLIT_MAX = 96;
  var dragging = null;

  function splitPercent(clientX, left, width) {
    if (!width) return 50;
    var p = ((clientX - left) / width) * 100;
    if (p < SPLIT_MIN) return SPLIT_MIN;
    if (p > SPLIT_MAX) return SPLIT_MAX;
    return p;
  }

  function setSplit(box, clientX) {
    var rect = box.getBoundingClientRect();
    box.style.setProperty("--am-split", splitPercent(clientX, rect.left, rect.width) + "%");
  }

  function cardStep(root) {
    var track = root.querySelector("[data-am-track]");
    var card = root.querySelector("[data-am-slide]");
    if (!track || !card) return 0;
    var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  function go(root, n) {
    var track = root.querySelector("[data-am-track]");
    var count = Number(root.getAttribute("data-count") || 0);
    if (!track || count < 2) return;
    var i = ((n % count) + count) % count;
    root.dataset.index = String(i);
    track.style.transform = "translate3d(" + -i * cardStep(root) + "px,0,0)";
  }

  function bind(root) {
    if (root.dataset.amBound === "1") return;
    root.dataset.amBound = "1";
    root.dataset.index = "0";
    go(root, 0);
  }

  function boot() {
    document.querySelectorAll("[data-am-rail]").forEach(bind);
  }

  function endDrag() {
    if (!dragging) return;
    dragging.classList.remove("is-dragging");
    dragging = null;
  }

  if (typeof document !== "undefined") {
    document.addEventListener("pointerdown", function (event) {
      var box = event.target.closest("[data-am-compare]");
      if (!box) return;
      event.preventDefault();
      dragging = box;
      box.classList.add("is-dragging");
      if (box.setPointerCapture && event.pointerId != null) {
        box.setPointerCapture(event.pointerId);
      }
      setSplit(box, event.clientX);
    });

    document.addEventListener("pointermove", function (event) {
      if (!dragging) return;
      setSplit(dragging, event.clientX);
    });

    document.addEventListener("pointerup", endDrag);
    document.addEventListener("pointercancel", endDrag);

    document.addEventListener("click", function (event) {
      var prev = event.target.closest("[data-am-rail-prev]");
      var next = event.target.closest("[data-am-rail-next]");
      if (!prev && !next) return;
      var root = (prev || next).closest("[data-am-rail]");
      if (!root) return;
      event.preventDefault();
      var i = Number(root.dataset.index || 0);
      go(root, prev ? i - 1 : i + 1);
    });

    document.addEventListener("shopify:section:load", boot);

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", boot);
    } else {
      boot();
    }
  }

  if (typeof window !== "undefined") {
    window.addEventListener("resize", function () {
      document.querySelectorAll("[data-am-rail]").forEach(function (root) {
        go(root, Number(root.dataset.index || 0));
      });
    });
  }

  if (typeof module !== "undefined" && module.exports) {
    module.exports = { splitPercent: splitPercent };
  }
})();
